export const FETCHING_HOTEL_DESTINATION_SUGGESTS_REQUEST =
  "FETCHING_HOTEL_DESTINATION_SUGGESTS_REQUEST";
export const FETCHING_HOTEL_DESTINATION_SUGGESTS_SUCCESS =
  "FETCHING_HOTEL_DESTINATION_SUGGESTS_SUCCESS";
export const FETCHING_HOTEL_DESTINATION_SUGGESTS_FAILURE =
  "FETCHING_HOTEL_DESTINATION_SUGGESTS_FAILURE";
